import {AsyncPipe, NgTemplateOutlet} from "@angular/common";
import {Component, ContentChild, inject, Input, OnInit, TemplateRef} from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router} from "@angular/router";
import {Observable, tap} from "rxjs";
import {LoadingService} from "../service/loading.service";

@Component({
    selector: 'euroports-loading-indicator',
    imports: [
        MatProgressSpinner,
        AsyncPipe,
        NgTemplateOutlet
    ],
    templateUrl: './loading-indicator.component.html',
    styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent implements OnInit {
  private loadingService = inject(LoadingService);
  private router = inject(Router);


  loading$: Observable<boolean>;

  @Input()
  detectRouteTransitions = false;

  @ContentChild("loading")
  customLoadingIndicator: TemplateRef<null> | null = null;

  constructor() {
    this.loading$ = this.loadingService.loading$;
  }

  ngOnInit() {
    if (this.detectRouteTransitions) {
      this.router.events
        .pipe(
          tap((event) => {
            if (event instanceof RouteConfigLoadStart) {
              this.loadingService.loadingOn();
            } else if (event instanceof RouteConfigLoadEnd) {
              this.loadingService.loadingOff();
            }
          })
        )
        .subscribe();
    }
  }
}
